<div class="microsoft-graph-admin-page">
  <ion-card>
    <ion-card-header>
      <ion-card-title>Microsoft Graph profilképek</ion-card-title>
      <ion-card-subtitle>
        Intézményi Azure app beállítások a Microsoft 365 profilképek lekéréséhez.
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <ion-item lines="full">
        <ion-label>
          <h2>Graph profilkép lekérés engedélyezése</h2>
          <p>Ha nincs bekapcsolva vagy nincs kép, a rendszer továbbra is az ui-avatars képet használja.</p>
        </ion-label>
        <ion-toggle slot="end" [(ngModel)]="settings.enabled"></ion-toggle>
      </ion-item>

      <ion-grid>
        <ion-row>
          <ion-col size="12" sizeMd="6">
            <ion-item>
              <ion-label position="stacked">Tenant ID</ion-label>
              <ion-input [(ngModel)]="settings.tenant_id" autocomplete="off"></ion-input>
            </ion-item>
          </ion-col>

          <ion-col size="12" sizeMd="6">
            <ion-item>
              <ion-label position="stacked">Client ID</ion-label>
              <ion-input [(ngModel)]="settings.client_id" autocomplete="off"></ion-input>
            </ion-item>
          </ion-col>

          <ion-col size="12">
            <ion-item>
              <ion-label position="stacked">
                Client secret
                <span *ngIf="settings.has_client_secret" class="secret-state">(van mentett secret)</span>
              </ion-label>
              <ion-input
                type="password"
                [(ngModel)]="settings.client_secret"
                autocomplete="new-password"
                placeholder="Hagyd üresen, ha nem szeretnéd módosítani"
              ></ion-input>
            </ion-item>
          </ion-col>

          <ion-col size="12" class="actions">
            <ion-button color="primary" (click)="saveSettings()" [disabled]="saving || loading">
              {{ saving ? 'Mentés...' : 'Mentés' }}
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>

      <ion-note color="medium">
        A secret biztonsági okból nem kerül visszatöltésre a böngészőbe. Üres mezővel mentve a korábbi érték megmarad.
      </ion-note>
    </ion-card-content>
  </ion-card>
</div>
